import Model from '../models'
import API from '../../api'

Model.Bundle.createAction('FETCH_ALL', (options) => {
  if (options == null) {
    options = {}
  }

  return API.post('bundles', options)
})

Model.Bundle.createAction('CONFIGURATION_AVAILABILITY', (options) => {
  return API.get(`bundles/${options.id}/configuration`, options)
})

export default Model.Bundle.actions
